/**
 * TODO STE-1606: replace this placeholder header with proper JSDoc and a Storybook story
 * WIP
 */
import { css, cx } from "@emotion/css";
import Typography from "@mui/material/Typography";

import { FontSizes } from "@/assets/fonts.ts";
import { Icons } from "@/assets/icons.ts";
import { useStyles } from "@/hooks/useStyles.ts";
import { Theme } from "@/theme/CreateTheme.ts";
import { suffixId } from "@/uiKit/atoms/utils/ids.ts";
import { StyleType } from "@/uiKit/StyleTypes.ts";

type FilePreviewType = {
  /** Id of the wrapper; the remove (trash) icon gets `${id}-delete`. */
  id?: string;
  name: string;
  onClick: () => void;
  deletable?: boolean;
  className?: string;
};

export const FilePreview = ({ id, name, onClick, className }: FilePreviewType & StyleType) => {
  const styles = useStyles(makeStyles);

  const handleRemove = () => {
    onClick();
  };

  return (
    <div id={id} className={cx(styles.container, className)}>
      <Icons.trash id={suffixId(id, "delete")} onClick={handleRemove} className={styles.icon} />
      <Typography variant="body" className={styles.name}>
        {name}
      </Typography>
    </div>
  );
};

const makeStyles = (theme: Theme) => ({
  container: css`
    display: inline-flex;
    padding-left: ${theme.spacing(4)};
    align-items: center;
  `,
  name: css`
    padding-left: ${theme.spacing(4)};
    white-space: nowrap;
    word-break: break-all;
    overflow: hidden;
    text-overflow: clip;
  `,
  icon: css({
    cursor: "pointer",
    width: FontSizes.body,
    height: FontSizes.body,
  }),
});
